import HowToStartPlaying from '@base/features/help/components/howToStart';
import { Switch } from 'react-router-dom';
import { useRouteMatch } from 'react-router-dom';
import { Redirect, Route } from 'react-router';
import { MAIN_ROUTES } from '@base/features/routing/constants/mainRoutes';
import FAQ from '@base/features/help/components/faq';
import { ReactChild } from 'react';
import { Routes } from '../constants/routes';

export default function BaseHelpContent(props: { children: ReactChild | ReactChild[] }) {
  const { path } = useRouteMatch();

  return (
    <main>
      <Switch>
        <Route exact path={path + '/' + Routes.HOW_TO_START_PLAYING}>
          <HowToStartPlaying />
        </Route>
        {props.children}
        <Route exact path={path + '/' + Routes.FAQ}>
          <FAQ />
        </Route>
        <Redirect from={MAIN_ROUTES.help} to={path + '/' + Routes.HOW_TO_START_PLAYING} />
      </Switch>
    </main>
  );
}
